import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import ProductLabels from "../../components/ProductLabels";
export const SectionItemSpecialLabels = (props) => {
    const { tags, freeModifierItemsCount, labelsCreator, availabilitySchedule } = props;
    return (h("div", { className: "m-item__labels" },
        tags.includes("New") && (h("span", { className: "m-badge m-badge--success" }, translate(t.theme_defaults.dish_label.new))),
        tags.includes("Recommended") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.recommended))),
        tags.includes("SpecialOffer") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.special))),
        freeModifierItemsCount > 0 && (h("span", { className: "m-badge m-badge--info", title: translate(t.theme_defaults.dish_label.special) },
            "+",
            freeModifierItemsCount)),
        h(ProductLabels, { labelsCreator: labelsCreator, schedule: availabilitySchedule !== null && availabilitySchedule !== void 0 ? availabilitySchedule : undefined })));
};
export default observer(SectionItemSpecialLabels);
